export const Text = 'text'
